<template>
  <div
    ref="gjWizard"
    class="add-organization gj-wizard"
  >
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="circle"
      class="h-100"
      @on-change="wizardToTop"
    >
      <!-- organization details tab  -->
      <tab-content
        title="Organization Details"
        :before-change="validationStepOne"
      >
        <validation-observer
          ref="billingAddres"
          tag="form"
        >
          <div class="col-12 col-md-8 col-lg-6 mx-auto px-0">
            <paper-simple>
              <validation-provider
                #default="{ errors }"
                name="Organization Name"
                rules="required"
              >
                <input-field
                  label="Organization Name"
                  label-position="top"
                  :error="errors.length ? errors[0] : null"
                >
                  <b-form-input
                    id="organizatin_name"
                    v-model="new_organization.name"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Enter organization name here..."
                  />
                </input-field>
              </validation-provider>
            </paper-simple>

            <paper-simple>
              <validation-provider
                #default="{ errors }"
                name="Address Line"
                rules="required"
              >
                <input-field
                  label="Address Line"
                  label-position="top"
                  :error="errors.length ? errors[0] : null"
                >
                  <b-form-input
                    id="address"
                    v-model="new_organization.address_line1"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Enter organization address here..."
                  />
                </input-field>
              </validation-provider>

              <input-field
                label="Address Line 2"
                label-position="top"
                class="mb-2"
              >
                <b-form-input
                  id="address2"
                  v-model="new_organization.address_line2"
                  placeholder="Enter organization address here..."
                />
              </input-field>

              <validation-provider
                #default="{ errors }"
                name="Country"
                rules="required"
              >
                <input-field
                  label="Country"
                  label-position="top"
                  :error="errors.length ? errors[0] : null"
                >
                  <b-form-select
                    id="country"
                    v-model="new_organization.country"
                    :selectable="option => option.value !== null"
                    :state="errors.length > 0 ? false : null"
                    :options="countryOptions"
                  />
                </input-field>
              </validation-provider>
              <validation-provider
                #default="{ errors }"
                name="City"
                rules="required"
              >
                <input-field
                  label="City"
                  label-position="top"
                  :error="errors.length ? errors[0] : null"
                >
                  <b-form-input
                    id="city"
                    v-model="new_organization.city"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Enter city here..."
                  />
                </input-field>
              </validation-provider>
            </paper-simple>
            <paper-simple>
              <validation-provider
                #default="{ errors }"
                name="VAT Number"
                rules="required"
              >
                <input-field
                  label="VAT Number"
                  label-position="top"
                  :error="errors.length ? errors[0] : null"
                >
                  <b-form-input
                    id="vat-number"
                    v-model="new_organization.vat_number"
                    type="number"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Enter VAT Number here..."
                  />
                </input-field>
              </validation-provider>
            </paper-simple>
          </div>
        </validation-observer>
      </tab-content>

      <!-- payment details tab -->
      <tab-content title="Payment Details">
        <validation-observer
          ref="socialRules"
          tag="form"
        >
          <div class="col-12 col-md-8 col-lg-6 mx-auto px-0">
            <payment
              :focused="focused"
              :has-voucher="hasVoucher"
              :card-error="cardError"
              :counter="counter"
              :voucher-value="new_organization.voucher"
              :name_card="new_organization.name_card"
              :focus-enabled="focusEnabled"
              :valid-voucher="validVoucher"
              :show-card="voucherName !== '30dayfree'"
              @card-confirmed="cardConfirmed"
              @toggle-voucher="toggleVoucher"
              @card-error="cardHasError"
              @change-voucher="changeVoucher"
              @change-focus="changeFocus"
            />
          </div>
        </validation-observer>
      </tab-content>

      <template
        slot="footer"
        slot-scope="props"
      >
        <div class="wizard-custom-footer col-12 col-lg-9">
          <b-button
            variant="bg-white"
            class="mr-1"
            :class="props.activeTabIndex > 0 ? 'transparent' : ''"
            @click="$router.push({ name: 'organization' })"
          >
            Cancel
          </b-button>
          <b-button
            v-if="props.activeTabIndex > 0"
            variant="bg-white"
            class="mr-1"
            @click="props.prevTab()"
          >
            Go Back
          </b-button>
          <b-button
            v-if="!props.isLastStep"
            class="wizard-footer-right"
            variant="bg-primary"
            @click="props.nextTab()"
          >
            Next
          </b-button>
          <b-button
            v-else
            class="wizard-footer-right finish-button"
            variant="bg-primary"
            @click="validationStepTwo()"
          >
            Done
          </b-button>
        </div>
      </template>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { required, email, url } from '@validations'
import countryOptions from '../../countries'
import Payment from '../../helpers/Payment.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    Payment,
  },
  data() {
    return {
      cardName: '',
      cardElement: undefined,
      cardError: false,
      focused: false,
      countryOptions,
      new_organization: {
        id: null,
        name: '',
        address_line1: '',
        address_line2: '',
        country: null,
        country_select: '',
        vat_number: '',
        city: '',
        voucher: '',
        name_card: '',
      },
      required,
      email,
      url,
      organizationId: null,
      hasVoucher: true,
      counter: 0,
      noOrganizations: false,
    }
  },
  computed: {
    organizations() {
      return this.$store.state.organization.organizations
    },
    hasOrganizations() {
      return this.organizations.length !== 0
    },
    voucherName() {
      return this.$route.query?.campaign || null
    },
    focusEnabled() {
      return !(this.voucherName === '50off' || this.voucherName === '100euoff' || this.voucherName === '100usoff')
    },
    validVoucher() {
      return this.voucherName === '50off'
      || this.voucherName === '100euoff'
      || this.voucherName === '100usoff'
      || this.voucherName === '30dayfree'
    },
  },
  created() {
    this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', true)
    this.$store.commit('app/SET_ORGANIZATION_ID', null)

    this.$store
      .dispatch('organization/fetchOrganizations', {
        pageSize: 5,
        pageIndex: 0,
      })
      .then(() => {
        if (this.organizations.length < 1) {
          this.noOrganizations = true
        }
      })
      .catch(() => {})

    if (this.validVoucher) {
      this.new_organization.voucher = this.voucherName
    }
  },
  methods: {
    toggleVoucher(val) {
      this.hasVoucher = val
    },
    cardHasError(val) {
      this.cardError = val
    },
    changeVoucher(val) {
      this.new_organization.voucher = val
    },
    changeFocus(val) {
      this.focused = val
    },

    formSubmitted() {
      const country = this.countryOptions.find(
        c => c.value === this.new_organization.country,
      )
      const organization = {
        name: this.new_organization.name,
        addressLine1: this.new_organization.address_line1,
        addressLine2: this.new_organization.address_line2,
        country: country.text,
        state: this.new_organization.country_select,
        city: this.new_organization.city,
        vatNumber: this.new_organization.vat_number,
        voucher: this.new_organization.voucher,
      }
      this.$store
        .dispatch('organization/addOrganization', organization)
        .then(res => {
          const { id } = res.data.result
          this.organizationId = id

          if (this.hasVoucher && this.focusEnabled) {
            this.selectOrganization()
            return
          }

          this.$store
            .dispatch('payments/addPaymentMethod', this.organizationId)
            .then(() => {
              this.counter++
            })
            .catch(error => {
              this.$store.commit('app/TOGGLE_OVERLAY', false)
              this.errorToast(error.response?.data?.errors[0])
            })
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0])
          this.$store.commit('app/TOGGLE_OVERLAY', false)
          this.new_organization.voucher = ''
        })
    },

    cardConfirmed() {
      this.$store
        .dispatch('organization/updateOrganization', {
          organizationId: this.organizationId,
          activate: true,
        })
        .then(() => {
          this.selectOrganization()
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating organization details.')
        })
    },

    selectOrganization() {
      this.$store.commit('app/TOGGLE_OVERLAY', false)
      if (this.noOrganizations) {
        localStorage.setItem(
          'welcomeMessage',
          'Congratulations! You have created your first organization in Captain.',
        )
      }
      this.$store.commit('app/SET_ORGANIZATION_ID', this.organizationId)
      this.$router.push({ name: 'project', params: { projectId: null } })
    },

    validationStepOne() {
      return new Promise((resolve, reject) => {
        this.$refs.billingAddres.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },

    validationStepTwo() {
      const cardElementContainer = document.querySelector('#card-element')
      const cardElementFocus = cardElementContainer?.classList.contains('StripeElement--focus')
      const cardElementEmpty = cardElementContainer?.classList.contains('StripeElement--empty')

      if (cardElementFocus) cardElementContainer.blur()

      return new Promise((resolve, reject) => {
        this.$refs.socialRules.validate().then(success => {
          setTimeout(() => {
            if ((!this.focused && this.new_organization.voucher === '') || cardElementEmpty) {
              this.cardError = true
            }
            if (success) {
              if (!this.hasVoucher && this.cardError) {
                reject()
                return
              }
              resolve(true)
              this.submit()
            } else {
              reject()
            }
          }, 0)
        })
      })
    },

    submit() {
      this.$store.commit('app/TOGGLE_OVERLAY', true)
      if (this.organizationId === null || this.hasVoucher) {
        this.formSubmitted()
      } else {
        this.counter++
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';

.form-group {
  margin-bottom: 24px;
}
</style>
